import LoginRecoverForm from 'components/auth/LoginRecoverForm/container';

export default LoginRecoverForm;
